import { render } from "./PopupWhats.vue?vue&type=template&id=2444417e&scoped=true"
import script from "./PopupWhats.vue?vue&type=script&async=true&lang=js"
export * from "./PopupWhats.vue?vue&type=script&async=true&lang=js"

import "./PopupWhats.vue?vue&type=style&index=0&id=2444417e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2444417e"]])

export default __exports__